import { Link } from "react-router-dom";
import { Flex, Image, Grid, Button, Row, Col, Space, Typography } from "antd";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import MyText from "../../components/UI/Text/MyText";
import { AppleOutlined, AndroidOutlined } from "@ant-design/icons";
import { clrs } from "../../constants/colors";

// Image imports
import people from "../../images/people.png";
import laptop_blue from "../../images/home/laptop_blue@3x.png";
import laptop_black from "../../images/home/laptop_black@3x.png";
import edit from "../../images/home/edit@3x.png";
import email from "../../images/home/email@3x.png";
import exchangePeople from "../../images/home/exchangePeople@3x.png";
import handshake from "../../images/home/handshake@3x.png";
import building from "../../images/home/building@3x.png";
import electricity from "../../images/home/electricity@3x.png";
import businessPerson from "../../images/home/businessPerson@3x.png";
import health from "../../images/home/health@3x.png";
import art from "../../images/home/art@3x.png";
import garden from "../../images/home/garden@3x.png";
import camera from "../../images/home/camera@3x.png";
import settings from "../../images/home/settings@3x.png";
import earth from "../../images/home/earth@3x.png";
import architecture from "../../images/home/architecture@3x.png";
import graduate from "../../images/home/graduate@3x.png";
import settingsAdjust from "../../images/home/settingsAdjust@3x.png";
import transport from "../../images/home/transport@3x.png";
import suitCase from "../../images/home/case@3x.png";

const { useBreakpoint } = Grid;
const { Text } = Typography;

const HomePage = () => {
  const screens = useBreakpoint();

  return (
    <div>
      <Flex
        style={{ width: "100%", position: "relative" }}
        vertical
        align="center"
      >
        <Header />
        <Flex
          style={{
            width: "100%",
            paddingTop: 150,
            minHeight: 800,
            paddingLeft: 20,
            paddingBottom: 20,
          }}
          vertical
          align="center"
          justify="flex-start"
        >
          <Flex
            style={{
              width: "100%",
              maxWidth: 1440,
              flexDirection: screens.md ? "row" : "column",
            }}
            align="flex-start"
            justify="space-between"
          >
            <Flex
              style={{ width: "100%", maxWidth: 800, paddingTop: "100px" }}
              gap={15}
              vertical
              align="flex-start"
            >
              <MyText strong size="large" style={{ color: clrs.blackerBlue }}>
                Төслийн ерөнхий танилцуулга
              </MyText>
              <MyText>
                Монгол улсын Боловсролын яам нь Холбооны Бүгд Найрамдах Герман
                улсын Тюринген мужийн Эрфуртын Худалдаа Аж Үйлдвэрийн Танхим,
                ФАВ Сервис-Ашгийн бус ХХК, мөн “ХӨГЖИЛ” - Мэргэжлийн чиг
                баримжаа, боловсрол олгох төвтэй хамтран ажиллах гэрээ
                байгуулсан. Монгол залуучуудад хосмог мэргэжлийн боловсрол
                олгох, ажил мэргэжлийн чиг баримжаа олгох үйл ажиллагааг
                эрчимжүүлэхийн тулд 2024-2025 оны хичээлийн жилд ерөнхий
                боловсролын 20 сургуулийг хэв шинж, байршил, хүүхдийн тоо
                зэргийг харгалзан сонгож загвар төсөл хэрэгжүүлэхээр болсон юм.
                Төслийн баг 2 аймаг, нийслэлийн нийт 20 сургуулийн 11 ба 12
                дугаар ангийн 7000 суралцагчид хүрч ажиллахаар төлөвлөж байна.
                Тус төслийн хүрээнд Монгол улсын өөрийн онцлог, мэргэжилтэй
                ажиллах хүчний дутагдал зэргийг харгалзан үзэж хүүхэд
                залуучуудад ажил мэргэжлээ зөв сонгоход дэмжлэг үзүүлэх,
                мэргэжлийн боловсролын хосмог сургалтыг хөгжүүлэх зорилготойгоор
                туршилт судалгааны ажил хамтран гүйцэтгэх юм. Энэхүү төсөл
                хэрэгжсэнээр ерөнхий боловсролын сургуулийн ахлах ангийн
                суралцагчид болон 18-26 насны залууст герман хэлний В2 түвшний
                шалгалтад тэнцсэн тохиолдолд Тюринген мужид мэргэжлийн боловсрол
                эзэмших чиглэлээр үнэ төлбөргүй суралцангаа ажиллах боломж
                нэмэгдэх юм.
              </MyText>
            </Flex>

            <Flex
              vertical
              align="center"
              justify="center"
              style={{ width: "100%", minHeight: 300, padding: "40px 0" }}
            >
              <Image
                preview={false}
                src={people}
                style={{ maxWidth: "100%", width: 400, height: "auto" }}
              />

              <Row
                gutter={[16, 16]}
                justify="center"
                align="middle"
                style={{ marginTop: 24 }}
              >
                <Col>
                  <Button
                    type="default"
                    size="large"
                    onClick={() =>
                      window.open(
                        "https://apps.apple.com/at/app/fav-berufe/id6740324901?l=en-GB&platform=iphone",
                        "_blank"
                      )
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 16px",
                      borderRadius: "12px",
                      border: "1px solid #d9d9d9",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                      height: "auto",
                    }}
                  >
                    <AppleOutlined style={{ fontSize: 28 }} />
                    <Space
                      direction="vertical"
                      size={0}
                      style={{ marginLeft: 12 }}
                    >
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        Download on the
                      </Text>
                      <Text strong style={{ fontSize: 16 }}>
                        App Store
                      </Text>
                    </Space>
                  </Button>
                </Col>

                <Col>
                  <Button
                    type="default"
                    size="large"
                    onClick={() =>
                      window.open(
                        "https://play.google.com/store/apps/details?id=org.example.FAV.Berufe",
                        "_blank"
                      )
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 16px",
                      borderRadius: "12px",
                      border: "1px solid #d9d9d9",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                      height: "auto",
                    }}
                  >
                    <AndroidOutlined style={{ fontSize: 28 }} />
                    <Space
                      direction="vertical"
                      size={0}
                      style={{ marginLeft: 12 }}
                    >
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        Get it on
                      </Text>
                      <Text strong style={{ fontSize: 16 }}>
                        Google Play
                      </Text>
                    </Space>
                  </Button>
                </Col>
              </Row>
            </Flex>
          </Flex>
          <Flex style={{ width: "100%", padding: 20 }} vertical align="center">
            <MyText
              style={{
                color: clrs.blackerBlue,
                fontWeight: "bold",
                fontSize: "1.5rem",
                marginBottom: 30,
              }}
            >
              Ажил мэргэжлийн чиг баримжаа олгох загвар төсөл
            </MyText>
            <Flex
              style={{ width: "100%", maxWidth: 1440, paddingTop: 20, gap: 15 }}
              wrap="wrap"
              align="center"
              justify="center"
            >
              <BannerItem
                image={<Image preview={false} src={laptop_blue} width={64} />}
                text="Цахим хуудсанд бүртгүүлсэн байх"
              />
              <BannerItem
                image={<Image preview={false} src={edit} width={64} />}
                text="Мэргэжлийн чиглэл сонгох"
              />
              <BannerItem
                image={<Image preview={false} src={email} width={58} />}
                text="Танилцуулгын урилга хүлээн авах"
              />
              <BannerItem
                image={
                  <Image preview={false} src={exchangePeople} width={58} />
                }
                text="Ганцаарчилсан зөвлөгөө"
              />
              <BannerItem
                image={<Image preview={false} src={handshake} width={64} />}
                text="Ирээдүйн мэргэжлээ сонгох"
              />
            </Flex>
          </Flex>
        </Flex>

        <Flex style={{ width: "100%", padding: 20 }} vertical align="center">
          <MyText
            style={{
              color: clrs.blackerBlue,
              fontWeight: "bold",
              fontSize: "1.5rem",
              marginBottom: 30,
            }}
          >
            Мэргэжлийн чиглэл
          </MyText>
          <Flex
            wrap="wrap"
            gap={20}
            justify="center"
            style={{ maxWidth: 1440 }}
          >
            {professionList.map((item) => (
              <ProfItem
                key={item.number}
                number={item.number}
                image={<Image preview={false} src={item.icon} width={64} />}
                text={item.text}
              />
            ))}
          </Flex>
        </Flex>

        <Footer />
      </Flex>
    </div>
  );
};

const BannerItem = ({ image, text }) => (
  <Flex
    style={{
      width: 250,
      padding: 20,
      backgroundColor: "white",
      height: 150,
      borderRadius: 8,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    }}
    vertical
    align="center"
    justify="center"
    gap={10}
  >
    {image}
    <MyText
      style={{ color: clrs.black, textAlign: "center", fontSize: "0.9rem" }}
      strong
    >
      {text}
    </MyText>
  </Flex>
);

const ProfItem = ({ image, text, number }) => (
  <Link to={`/profession/${number}`} style={{ textDecoration: "none" }}>
    <Flex
      style={{
        width: 250,
        padding: 20,
        backgroundColor: "#e8e8e8",
        height: 150,
        borderRadius: 8,
        cursor: "pointer",
        transition: "all 0.3s",
      }}
      vertical
      align="center"
      justify="center"
      gap={10}
    >
      {image}
      <MyText
        style={{ color: clrs.black, textAlign: "center", fontSize: "0.9rem" }}
        strong
      >
        {text}
      </MyText>
    </Flex>
  </Link>
);

const professionList = [
  { number: 1, icon: building, text: "Барилга, архитектур, хэмжил зүй" },
  { number: 2, icon: electricity, text: "Цахилгаан, электроник" },
  { number: 3, icon: businessPerson, text: "Үйлчилгээ үзүүлэх" },
  { number: 4, icon: health, text: "Эрүүл мэнд" },
  { number: 5, icon: laptop_black, text: "Мэдээллийн технологи, компьютер" },
  { number: 6, icon: art, text: "Урлаг, соёл, дизайн" },
  {
    number: 7,
    icon: garden,
    text: "Хөдөө аж ахуй, байгаль, хүрээлэн буй орчин",
  },
  { number: 8, icon: camera, text: "Хэвлэл мэдээлэл" },
  { number: 9, icon: settings, text: "Металл ба механик инженерчлэл" },
  { number: 10, icon: earth, text: "Байгалийн шинжлэх ухаан" },
  { number: 11, icon: architecture, text: "Үйлдвэрлэл ба бэлэн бүтээгдэхүүн" },
  {
    number: 12,
    icon: graduate,
    text: "Нийгмийн харилцаа ба сурган хүмүүжүүлэх ухаан",
  },
  { number: 13, icon: settingsAdjust, text: "Техник, технологи" },
  { number: 14, icon: transport, text: "Тээвэр, ложистик" },
  { number: 15, icon: suitCase, text: "Эдийн засаг, захиргаа" },
];

export default HomePage;
